/**
 *  Check if brand specific feature is enabled
 * */
export const isBrandSpecificFeatureEnabled = (featureId, settings) => {
  return settings?.features?.active?.includes(featureId);
};
